import React from 'react';
import { Skeleton } from '@shared/components/Skeleton';
import { Box, Flex } from '@withjoy/joykit';

export const ThingsToDoLoadingSkeleton = () => {
  return (
    <Flex
      flexDirection={['column', 'row']}
      width="100%"
      gap={['24px', '32px']}
      alignItems={['stretch', 'flex-start']}
    >
      <Box
        width="100%"
        maxWidth={['100%', '440px']}
      >
        <Skeleton
          width="100%"
          height={['180px', '216px']}
          borderRadius={4}
        />
      </Box>
      <Box
        width="100%"
        maxWidth={['100%', '352px']}
        display="flex"
        flexDirection="column"
        gap={'8px'}
      >
        {[1, 2, 3].map(i => (
          <Flex
            key={i}
            alignItems="flex-start"
            gap={['12px', '16px']}
            marginBottom={['16px', '24px']}
          >
            <Skeleton
              width={50}
              height={50}
              borderRadius={4}
            />
            <Flex
              flexDirection="column"
              gap={1}
              flex="1"
            >
              <Skeleton
                width="80%"
                height={15}
                borderRadius={4}
              />
              <Skeleton
                width="60%"
                height={15}
                borderRadius={4}
              />
              <Skeleton
                width="70%"
                height={15}
                borderRadius={4}
              />
            </Flex>
          </Flex>
        ))}
      </Box>
    </Flex>
  );
};
